export const BillBtnIcon = ({ ...rest }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M14.167 1.6665H5.83366C4.91318 1.6665 4.16699 2.4127 4.16699 3.33317V18.3332L6.25033 16.6665L7.91699 18.3332L10.0003 16.6665L12.0837 18.3332L13.7503 16.6665L15.8337 18.3332V3.33317C15.8337 2.4127 15.0875 1.6665 14.167 1.6665Z"
        stroke="#15112D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 5H12.5"
        stroke="#F7AD3C"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 8.3335H12.5"
        stroke="#19AE57"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 11.6665H8.33333"
        stroke="#FD561F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
